import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IFormSummaryOfPerformance } from "../Models/Forms/IFormSummaryOfPerformance";

@Injectable()
export class FormSummaryOfPerformanceService  extends  BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormSummaryOfPerformance(id: number) {
    return this._http.get(this._baseUrl + "api/FormSummaryOfPerformance/" + id)
      .map((response: IFormSummaryOfPerformance) => response as IFormSummaryOfPerformance)
      .catch(this.errorHandler);
  }

  insertUpdateFormSummaryOfPerformance(formSummaryOfPerformanceDetails: IFormSummaryOfPerformance) {
    return this._http.post(this._baseUrl + 'api/FormSummaryOfPerformance', formSummaryOfPerformanceDetails)
      .map((response: IFormSummaryOfPerformance) => response as IFormSummaryOfPerformance)
      .catch(this.errorHandler);
  }

  validateForm(id: number) {
    return this._http.get(this._baseUrl + "api/FormSummaryOfPerformance/ValidateForm" + id)
      .map((response: string[]) => response as string[])
      .catch(this.errorHandler)
  }

  deleteSummaryOfPerformance(id) {
    return this._http.delete(this._baseUrl + "api/FormSummaryOfPerformance" + id)
      .map((response: IFormSummaryOfPerformance) => response as IFormSummaryOfPerformance)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
 
}
